module.exports = __webpack_public_path__ + "static/media/step3.b9b96f72.webp";